








































































import Vue from 'vue'
import { BlockChecklistInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'BlockChecklistEl',
  props: {
    templateItemData: {
      type: Object as () => BlockChecklistInterface,
      required: true
    }
  }
})
